"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getRange = exports.getNumPages = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Flex = require("../../../Layout/Flex");

var _Constant = require("../../Constant");

var _Constant2 = require("../../../Constant");

var _Color = require("../../../Constant/Color");

var _newArrowRightPurple = _interopRequireDefault(require("../../../assets/images/new-arrow-right-purple.svg"));

var _arrowLeftPurple = _interopRequireDefault(require("../../../assets/images/arrow-left-purple.svg"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background: ", ";\n  border-radius: 2px;\n  color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border: none;\n  background-color: transparent;\n  padding: 1.3rem 0;\n  width: 3.8rem;\n  height: 3.8rem;\n  font-size: 1.2rem;\n  font-weight: 700;\n  cursor: pointer;\n  color: ", ";\n  font-family: ", ";\n  outline: none;\n\n  /* Focus styles on on keyboard focus */\n  &[data-focus-visible-added]:focus {\n    border: 4px solid ", ";\n    border-radius: 2px;\n    padding-top: 0.9rem;\n    padding-bottom: 0.9rem;\n  }\n\n  &:hover {\n    background-color: ", ";\n    border-radius: 2px;\n    /* necessary to restate text color for active buttons */\n    color: ", ";\n  }\n\n  &:active {\n    background: ", ";\n    border-radius: 2px;\n    color: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  flex-direction: row;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  height: 72px;\n  align-items: center;\n  justify-content: center;\n  border-top: 1px solid ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PagerContainer = (0, _styledComponents.default)(_Flex.FlexContainer)(_templateObject(), _Constant.Color.GREY_3);
var PageNumbers = (0, _styledComponents.default)(_Flex.FlexContainer)(_templateObject2());

var PageButton = _styledComponents.default.button(_templateObject3(), _Constant.Color.BLACK_SOUL, _Constant2.Font.PRIMARY_FONT, _Color.FOCUS, _Color.GREY_3, _Constant.Color.BLACK_SOUL, _Constant.Color.PURPLE, _Constant.Color.WHITE);

var ActivePageButton = (0, _styledComponents.default)(PageButton)(_templateObject4(), _Constant.Color.PURPLE, _Constant.Color.WHITE);
/**
 * A helper function for Pager functionality.
 *
 * Given the initial data, and the slice size,
 * return the number of pages.
 *
 * @param {*} dataLength
 * @param {*} sliceSize
 */

var getNumPages = function getNumPages(dataLength, sliceSize) {
  return Math.ceil(dataLength / sliceSize);
};
/**
 * A helper function for Pager functionality.
 *
 * Given slice size, and the current page index,
 * return the beginning and the ending indices
 * for the page data slice.
 *
 * @param {*} sliceSize
 * @param {*} pageIndex
 */


exports.getNumPages = getNumPages;

var getRange = function getRange(sliceSize, pageIndex) {
  var beginningIndex = sliceSize * (pageIndex - 1);
  var endingIndex = sliceSize * pageIndex;
  return [beginningIndex, endingIndex];
};

exports.getRange = getRange;

var Pager = function Pager(_ref) {
  var numPages = _ref.numPages,
      currentPage = _ref.currentPage,
      onPageChange = _ref.onPageChange;
  var pageNumbers = [];

  for (var i = 1; i <= numPages; i++) {
    pageNumbers.push(i);
  }

  var nextPage = currentPage === pageNumbers.length ? 1 : currentPage + 1;
  var prevPage = currentPage === 1 ? pageNumbers.length : currentPage - 1;
  return /*#__PURE__*/_react.default.createElement(PagerContainer, null, /*#__PURE__*/_react.default.createElement(PageNumbers, null, /*#__PURE__*/_react.default.createElement(PageButton, {
    onClick: function onClick() {
      return onPageChange(prevPage);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _arrowLeftPurple.default,
    alt: "Previous page"
  })), pageNumbers.map(function (index) {
    return index === currentPage ? /*#__PURE__*/_react.default.createElement(ActivePageButton, {
      onClick: function onClick() {
        return onPageChange(index);
      },
      key: index
    }, index) : /*#__PURE__*/_react.default.createElement(PageButton, {
      onClick: function onClick() {
        return onPageChange(index);
      },
      key: index
    }, index);
  }), /*#__PURE__*/_react.default.createElement(PageButton, {
    onClick: function onClick() {
      return onPageChange(nextPage);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _newArrowRightPurple.default,
    alt: "Next page"
  }))));
};

Pager.propTypes = {
  numPages: _propTypes.default.number,
  currentPage: _propTypes.default.number,
  onPageChange: _propTypes.default.func.isRequired
};
Pager.defaultProps = {
  numPages: 1,
  currentPage: 1
};
var _default = Pager;
exports.default = _default;